import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6920b635&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./style/index.scss?vue&type=style&index=0&id=6920b635&lang=scss&scoped=true&"
import style1 from "./style/stepDialog.scss?vue&type=style&index=1&lang=scss&"
import style2 from "./index.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6920b635",
  null
  
)

export default component.exports